// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"dc496d6d","242":"fa4c315d","337":"b76be968","891":"85d73163","998":"4fef471d"}[chunkId] + ".chunk.js";
};